<script>
import {
  shippingMethodOverviewProps,
  useShippingMethodOverview
} from "./mixin";
import Card from "@/components/molecules/card";
import Icon from "@/components/atoms/icon";
import LinkTo from "@/components/atoms/link-to";
import dateUtils from "@/utils/date";

export default {
  name: "ShippingMethodOverviewMobile",
  components: { Card, Icon, LinkTo },
  props: {
    ...shippingMethodOverviewProps()
  },
  setup(props) {
    const { iconName } = useShippingMethodOverview(props);
    return { iconName };
  },
  computed: {
    dateRetraitFormatted() {
      if (!this.dateRetrait) {
        return "";
      }
      return (
        dateUtils.formatDate(this.dateRetrait.date_du_jour) +
        "<br/>" +
        this.dateRetrait.heure_debut.replace(":", "h") +
        " à " +
        this.dateRetrait.heure_fin.replace(":", "h")
      );
    }
  }
};
</script>

<template>
  <Card
    class="c-shipping-method-mobile c-shipping-method-mobile--overview u-mt-md u-mb-lg"
    radius="md"
    elevation="md"
  >
    <div class="c-shipping-method-mobile__selector">
      <!-- TODO : composant image -->
      <Icon
        class="c-shipping-method-mobile__icon"
        :name="iconName"
      />
      <p class="c-shipping-method-mobile__label">
        {{ service.label }}
      </p>

      <p class="c-shipping-method-mobile__cost">
        {{ tarif }}
      </p>
    </div>
    <p class="c-shipping-method-mobile__time">
      <span v-html="dateRetrait"></span>
      <LinkTo
        v-if="service.type !== 'CC'"
        :to="{ path: './', query: { type_panier: typePanier }}"
        class="u-block u-mt-xs"
      >
        Modifier
      </LinkTo>
    </p>
  </Card>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-method-mobile.scss";
</style>
